var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"StandardBorderedButton",class:[
    _vm.color,
    { disabled: _vm.disabled },
    { fluid: _vm.fluid },
    { backward: _vm.backwardsIcon },
    { 'desktop-fluidity': _vm.desktopFluidity },
  ],on:{"click":function($event){return _vm.emitClick()}}},[(_vm.backwardsIcon)?_c('Arrow',{attrs:{"color":"twilight"}}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }